import React from "react";
import PropTypes from "prop-types";
import { PieChart, Pie, Sector, Cell } from "recharts";

// const renderActiveShape = (props, values) => {
//   const RADIAN = Math.PI / 180;
//   const {
//     cx,
//     cy,
//     midAngle,
//     innerRadius,
//     outerRadius,
//     startAngle,
//     endAngle,
//     fill,
//     payload,
//     percent,
//     value,
//     pipeRow,
//   } = props;
//   ////console.log("values", values);
//   const sin = Math.sin(-RADIAN * midAngle);
//   const cos = Math.cos(-RADIAN * midAngle);
//   const sx = cx + (outerRadius + 10) * cos;
//   const sy = cy + (outerRadius + 10) * sin;
//   const mx = cx + (outerRadius + 30) * cos;
//   const my = cy + (outerRadius + 30) * sin;
//   const ex = mx + (cos >= 0 ? 1 : -1) * 22;
//   const ey = my;
//   const textAnchor = cos >= 0 ? "start" : "end";

//   return (
//     <g>
//       <text x={cx} y={cy - 20} dy={8} textAnchor="middle" fill="#000">
//         87
//       </text>
//       <text
//         x={cx}
//         y={cy}
//         dy={8}
//         textAnchor="middle"
//         style={{ fontSize: 11 }}
//         fill="#000"
//       >
//         Total
//       </text>
//       <text
//         x={cx}
//         y={cy + 14}
//         dy={8}
//         textAnchor="middle"
//         style={{ fontSize: 11 }}
//         fill="#000"
//       >
//         Test Results
//       </text>
//       <Sector
//         cx={cx}
//         cy={cy}
//         innerRadius={innerRadius}
//         outerRadius={outerRadius}
//         startAngle={startAngle}
//         endAngle={endAngle}
//         fill={fill}
//       />
//     </g>
//   );
// };

function pipeChat(props) {
  const { typeOfCase, caseCount, text1, text2 } = props;
  const data = typeOfCase || [];
  // ////console.log(data, caseCount);

  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";

    return (
      <g>
        <text x={cx} y={cy - 20} dy={8} textAnchor="middle" fill="#000">
          {caseCount}
        </text>
        <text
          x={cx}
          y={cy}
          dy={8}
          textAnchor="middle"
          style={{ fontSize: 11 }}
          fill="#000"
        >
          {text1}
        </text>
        <text
          x={cx}
          y={cy + 14}
          dy={8}
          textAnchor="middle"
          style={{ fontSize: 11 }}
          fill="#000"
        >
          {text2}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </g>
    );
  };
  return (
    <div>
      <PieChart width={130} height={130}>
        <Pie
          data={data}
          cx={60}
          cy={60}
          activeIndex={1}
          activeShape={renderActiveShape}
          innerRadius={50}
          outerRadius={60}
          fill="#000000"
          paddingAngle={0}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    </div>
  );
}

pipeChat.propTypes = {};

export default pipeChat;
